<template lang="html">
    <div>
      <div class="flex justify-between px-0 mx:px-0 sm:space-x-2">
          <div v-if="videoLeaderEnabled" class="hidden">
            <button id="requestVideoLeaderButton" class="btn btn-secondary" @click="requestVideoLeaderWrapper()">Become video leader</button>
          </div>
          <div class="uppercase text-gray-900 font-bold text-left pt-2 hidden sm:block">
              {{ aspectRatio }}
          </div>
          <div class="space-x-2 sm:space-x-4 items-center flex z-50 sm:pt-0 justify-between sm:justify-end w-full sm:w-auto">
              <button class="btn btn-secondary px-2 py-1" onclick="toggleModal('#testConnection')" v-if="networkQualityTestEnabled">Check connection</button>
              <div class="bg-green-200 text-green-800 px-2 py-1 rounded-md inline-flex relative hidden" id="private-mode-badge"
                   data-tippy-content="You are now on Private mode. Only your production team can hear your conversations; other guests wont be able to hear you.">
                  <span class="absolute inset-0 animate-ping bg-green-300 rounded-md -z-1"></span>
                  Private<span class="hidden sm:inline">&nbsp;mode</span>
              </div>

              <div class="bg-green-200 text-green-800 px-2 py-1 rounded-md inline-flex relative hidden" id="on-set-talk-badge"
                   data-tippy-content="A member of your Production team is now speaking to the actors or crew on the set">
                  <span class="absolute inset-0 animate-ping bg-green-300 rounded-md -z-1"></span>
                  On-set<span class="hidden sm:inline">&nbsp;talk</span>
              </div>

              <button class="px-2 py-1 underline text-gray-800 dark:text-gray-300" @click="onDarkModeToggle" v-if="darkModeEnabled">
                  Turn {{ darkModeOn ? 'off' : 'on'}}  dark mode
              </button>
              <div class="bg-yellow-200 text-yellow-800 px-2 py-1 rounded-md text-sm" id="stand-by-badge">
                  Waiting to be connected
              </div>
              <button class="btn btn-red px-2 py-1 rounded-md hidden" id="endOfSessionButton">
                Disconnect
              </button>
          </div>
      </div>
        <div id="videoContainer" class="mt-3" :class="{'horizontal' : (angle == 90 || angle == 270), 'videoContainerLandscape':isMobileLandscape}">
            <div id="mask-before" class="absolute z-30 opacity-50 bg-black"></div>
            <div id="mask-after" class="absolute z-30 opacity-50 bg-black"></div>
            <video :id="id" class="bg-black mx-auto relative left-0 right-0 transform transition-all duration-300" :class="getRotationAngle" :src="src" playsinline autoplay muted oncontextmenu="return false"> Your browser doesn't support HTML5 video </video>
            <div id="playbackOn" class="absolute z-50 text-shadow-md text-xl left-0 top-0 ml-5 mt-5 uppercase text-white font-bold flex items-center hidden text-sm sm:text-base">
                <div class="ml-1"> Playback </div>
                <div class="ml-1 hidden"> Preparing for Playback </div>
                <div class="ml-1 hidden"> Playback </div>
            </div>
            <div class="bg-gray-800 w-full text-center absolute text-white h-full flex flex-wrap justify-center items-center top-0 px-8 sm:px-20 font-bold" v-show="isSuspended">
                <div class="text-lg sm:text-xl">
                  <div class="text-xl sm:text-3xl">We'll be right back!</div>
                  <br />
                  Feel free to disconnect if you'd like. <br />
                  Rejoin by following your invitation link when ready.  <br />
                </div>
            </div>
            <div class="w-full text-center absolute right-0 top-0 text-white h-full flex flex-wrap items-end pb-16 px-20 font-light uppercase hidden" id="copyright">
                <div>
                    All videos hereby shown are protected by U.S. and International copyright laws. Reproduction and distribution of these without written permission of the sponsor is prohibited.
                </div>
            </div>
            <div class="absolute ptt-wrapper" v-show="isFullscreen || isMobileLandscape">
              <push-to-talk ref="pttOverlay" ptt-type="overlay"></push-to-talk>
            </div>

            <div class="absolute z-10 right-0 top-0 uppercase text-red-600 font-bold mt-5 text-right text-sm sm:text-base"
            :class="isMobileLandscape ? 'mr-32': 'mr-5'"
             data-tippy-content="The host has actived this mode to ensure a smoother connection." v-show="!isHighDataModeOn">
                LOW DATA MODE
            </div>
            <div id="recordingOn" class="absolute z-10 text-shadow-md text-2xl left-0 top-0 ml-5 mt-5 uppercase text-red-600 font-bold flex items-center hidden">
                <svg class="h-6 w-6 fill-current mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10 3a7 7 0 1 0 .001 13.999A7 7 0 0 0 10 3z"/></svg>
                <div class="ml-1"> REC </div>
            </div>
            <div id="participantInfo" class="w-full absolute left-0 bottom-0 text-white pl-5 sm:font-bold font-medium text-shadow z-40 text-xs sm:text-base hidden" :class='isVideoLeader ? "mb-24" : "mb-5"'>
              <div> {{ participant.name }} </div>
              <div> {{ participant.email }} </div>
              <div> {{ ip }} </div>
            </div>
            <div class="flex items-center w-full h-full absolute top-0 left-0 justify-center hidden"  id="viewportPlaceholderText" v-show="!isSuspended">
                <div class="z-10 text-shadow-md text-white text-4xl leading-9 font-bold">"The best camera <br /> is the one you <br /> have with you"</div>
            </div>
            <button type="button" class="flex items-center w-full absolute bottom-0 left-0 right-0 justify-center bg-red-500 cursor-pointer hover:bg-red-600 hidden" id="tapToUnmuteButton" style="z-index: 70">
                <div class="z-10 text-white text-xl font-bold text-center">
                    Tap here to unmute video
                </div>
            </button>

            <div class="controls flex justify-end"  :class='isVideoLeader ? "mb-24" : "mb-0"'>
                <button data-tippy-content="Enter fullscreen" class="text-white hover:text-gray-400 px-1 py-1 hidden lg:block" v-show="isHighDataModeOn" @click="toggleFullscreen()">
                    <!-- Full screen icon -->
                    <svg v-if="!isFullscreen" class="w-6 h-6 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M6.987 10.987l-2.931 3.031L2 11.589V18h6.387l-2.43-2.081 3.03-2.932-2-2zM11.613 2l2.43 2.081-3.03 2.932 2 2 2.931-3.031L18 8.411V2h-6.387z"/></svg>
                    <!-- Close full screen icon -->
                    <svg v-else class="w-6 h-6 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M4.1 14.1L1 17l2 2 2.9-3.1L8 18v-6H2l2.1 2.1zM19 3l-2-2-2.9 3.1L12 2v6h6l-2.1-2.1L19 3z"/></svg>
                </button>
            </div>
        </div>
    </div>
</template>
<script>

import commandsManager from 'general/CommandsManager'
import messageBroker from 'general/messageBroker';

import { requestVideoLeader, setVideoLeadershipListenersHTML5, setupVideoLeadershipMessageTypes } from 'mirror/video-leadership'

export default {
  props: {
    id: {},
    src: {},
    participant: {},
    ip: {},
    moon: {},
    videoLeaderEnabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    networkQualityTestEnabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    darkModeEnabled: {
      type: Boolean,
      required: false,
      default: false
    },
    roomWasSuspended: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      isFullscreen: false,
      isHighDataModeOn: true,
      demoModeOn: false,
      angle: 0,
      aspectRatio: "16:9",
	  isMirrorPlus: true,
      // Video leadership
      isVideoLeader: false,
      darkModeOn: false,
      isMobileLandscape: false,
      isSuspended: false,
    }
  },
  mounted(){
    // add a listener when the window gets focused again after being locked on iphone
    document.addEventListener('visibilitychange', () => {
      // if the video is not playing then play it
      if (!document.hidden) {
        this.resizeVideo();
      } 
    });

    // set listener to change the variable isFullscreen when user exits fullscreen via ESC or another method
    document.onwebkitfullscreenchange = (event) => {
      // document.fullscreenElement will point to the element that
      // is in fullscreen mode if there is one. If there isn't one,
      // the value of the property is null.
      if (document.fullscreenElement) {
      } else {
        // leaving fullscreen
        this.isFullscreen = false;
        const videoEl = $('#' + this.id);
        videoEl.css('top', '0rem')
        // add a resize to avoid a black screen
        window.setTimeout(()=>{
          this.resizeVideo();
        }, 500)
      }
    };
    this.isSuspended = this.roomWasSuspended;
    // resize video when window resizes
    window.addEventListener('resize', this.resizeVideo);
    window.resizeVideo = this.resizeVideo

    commandsManager
      .registerNewCommand('rotate_viewport', (data) => {
        this.rotateViewport(data.args.angle);
      })
      .registerNewCommand('mask_viewport', (data) => {
        this.maskViewport(data.args.aspectRatio);
      })
      .registerNewCommand('set_low_data_mode', (data) => {
        this.isHighDataModeOn = !data.args.lowDataModeOn;
        if (this.isHighDataModeOn == false && this.isFullscreen){
          this.isFullscreen = false;
          document.webkitCancelFullScreen();
        }
      })
      .registerNewCommand('set_demo_mode', (data) => {
        this.demoModeOn = data.args.demoModeOn;
      })
      .registerNewCommand('set_mirror_plus', (data) => {
        this.isMirrorPlus = data.args.is_mirror_plus;
      })
      .registerNewCommand('set_suspend_room', (data) => {
        this.isSuspended = data.args.is_suspended;
      });

    // setup video leadership and set the leader as false by default (as host is always the leader in the begining)
    const videoEl = $('#' + this.id)[0];
    setupVideoLeadershipMessageTypes(false, videoEl, this.setVideoLeaderCallback)

	  // get from local storage preference of dark mode
    let darkMode =  localStorage.getItem('mt_mirror_guest_dark_mode')
    // if the preference is not set then set it to true
	  if (darkMode == "true" || darkMode == null){
		  this.onDarkModeToggle();
	  }
  },
  methods: {
    playVideo(){
      $("#videoContainer .video")[0].play();
    },
    pauseVideo(){
      $("#videoContainer .video")[0].pause();
    },
    toggleFullscreen(){
      const video = $("#videoContainer video")[0];
      // for chrome
      if($.isFunction(video.webkitEnterFullscreen)) {
        // enable fullscreen
        if(!this.isFullscreen){
          $('#videoContainer')[0].webkitRequestFullScreen();
        }
        // exit full screen
        else {
          document.webkitCancelFullScreen();
        }
      }
      // for mozilla
      else if ($.isFunction(video.mozRequestFullScreen)) {
        // enable fullscreen
        if(!this.isFullscreen)
          $('#videoContainer')[0].mozRequestFullScreen();
        // exit fullscreen
        else
          document.mozCancelFullScreen();
      }
      else {
        alert('Your browsers doesn\'t support fullscreen');
      }
      // toggle fullscreen status
      this.isFullscreen = !this.isFullscreen;
      window.setTimeout(()=>{
        this.resizeVideo();
		    this.fixVideoHeight();
      } , 100)
    },
	fixVideoHeight(){
      const videoElWrapper = $('#videoContainer');
	  // Fix height when coming back from fullscreen
      const videoEl = $('#' + this.id);
	  // if the rotation angle is horizontal then the height to the top must always be 0, even on fullscreen
	  if (this.angle == 0 || this.angle == 180){
		if(this.isFullscreen) videoEl.css('top', '0rem');
		return;
	  };
      if(this.isFullscreen) videoEl.css('top', videoElWrapper.width()/8)
      if(!this.isFullscreen) videoEl.css('top', '0rem')
	},

    rotateViewport(angle){
      this.angle = angle;
    },
    maskViewport(aspectRatio){
      this.aspectRatio = aspectRatio;
      this.drawMaskViewport();
    },
    drawMaskViewport(){
      let ratio = this.aspectRatio.split(":").reduce((a, b) => a/b);
      // left right
      const maskBefore = $("#mask-before")
      const maskAfter = $("#mask-after")

      const verticalClassListLeft = "inset-y-0 left-0"
      const verticalClassListRight = "inset-y-0 right-0"
	  // If the size is lower than the 16/9 aspect ratio then add the mask
	  // vertically
      if (ratio < (16/9)) {
        maskBefore.addClass(verticalClassListLeft).removeClass("inset-x-0 top-0");
        maskAfter.addClass(verticalClassListRight).removeClass("inset-x-0 bottom-0");
        maskBefore.css("height", "initial");
        maskAfter.css("height", "initial");
        const height = maskBefore.height();
        maskBefore.css("width", (height * (16 / 9 - ratio / 1)) / 2);
        maskAfter.css("width", (height * (16 / 9 - ratio / 1)) / 2);
      } else {
		// if the mask is horiziontal then add masks to the top and bottom
        // top bottom
        maskBefore
          .removeClass(verticalClassListLeft)
          .addClass("inset-x-0 top-0");
        maskAfter
          .removeClass(verticalClassListRight)
          .addClass("inset-x-0 bottom-0");
        maskBefore.css("width", "initial");
        maskAfter.css("width", "initial");
        const width = maskBefore.width();
	    // Set the size of the mask
        maskBefore.css("height", (width / 2) * (9 / 16 - 1 / ratio));
        maskAfter.css("height", (width / 2) * (9 / 16 - 1 / ratio))
      }
    },
    resizeVideo(){
      const videoEl = $('#' + this.id);
      const videoElWrapper = $('#videoContainer');
      const rotation = parseInt(this.angle);
      if(rotation == 0 || rotation == 180){
        videoEl.width(videoElWrapper.width());
      }
      if(rotation == 90 || rotation == 270){
        console.log(videoElWrapper.height());
        // HACK: For some reason after coming from fullscreen the width is 8px less thus the +8 ensures that this doesnt happen
        // although its not as nice because if the user never uses fullscreen they actually lose 8px of screen real state.
        videoEl.width(videoElWrapper.height() + 8);
      }
      // redraw mask
      this.drawMaskViewport();
      // hack to force the computed value to be updated
      this.isMobileLandscape = window.matchMedia("(orientation: landscape)").matches && window.matchMedia("(max-width: 990px)").matches;

      // Do not show PTT if it is a mobile landscape
      let secondPTTEl = document.querySelector("#PTTButtonSecond")
      if (secondPTTEl) secondPTTEl.classList.toggle("hidden", this.isMobileLandscape);

    },
    requestVideoLeaderWrapper(){
      const videoEl = $('#' + this.id);
      setVideoLeadershipListenersHTML5(videoEl[0])
      requestVideoLeader();
    },
    setVideoLeaderCallback(isVideoLeader){
      this.isVideoLeader = isVideoLeader;
    },
    onDarkModeToggle(){
      this.darkModeOn = !this.darkModeOn;
      if(this.darkModeOn) document.querySelector('html').classList.add('dark');
      else document.querySelector('html').classList.remove('dark');
	  // update local storage with dark mode preference
	  localStorage.setItem('mt_mirror_guest_dark_mode', this.darkModeOn ? 'true' : 'false');

    },
  },
    computed: {
        getRotationAngle(){
            this.resizeVideo();
	    this.fixVideoHeight();
            if (this.angle == 0){   return ''; }
            if (this.angle == 90){  return '-rotate-90' }
            if (this.angle == 180){ return '-rotate-180' }
            if (this.angle == 270){ return '-rotate-270' }
        }
    }
}
</script>
<style lang="scss" scoped>
.-rotate-270{
    transform: rotate(-270deg)!important;
}
#videoContainer{
    overflow: hidden;
    position: relative;
    width: 100%;
}
video{
    width: 100%;
    min-height: 26rem!important;

    @media screen and (max-width:'768px'){
        min-height: 14rem!important;
    }
}
.videoContainerLandscape{
  video {
    min-height: auto!important;
    margin-right: auto;
    margin-left: 0;
    width: 80%!important;
  }
    .ptt-wrapper {
      position: absolute;
      right: 0;
      bottom: 0;
      top: 0;
      width: 20%;
      .ptt {
        width: 100%;
        height: 100%;
        border-radius: 0px;
        border: none;
      }
    }
}
.ptt-wrapper{
                 right: 5rem;
                 bottom: 1.25rem;
                 z-index: 70;
                 .ptt {
                        border-radius: 50%;
                        height: 3.5rem;
                        width: 3.5rem;
                        border: 1px solid black;
                 }
}
.horizontal {
    height: 26.5rem;
}

.controls{
    position: absolute;
    z-index: 60;
    bottom: 0;
    left: 0;
    padding-right: 20px;
    padding-bottom: 20px;
    width: 100%;
}

</style>
